import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 谈判采购路由生成函数
 * @param modulePath
 * @param prefix
 * @param sideMenuTitle
 * @param applicableCompanyIdentities
 * @param roles
 * @param listRoute
 * @param needIcon
 * @returns <Object> route
 */
export default function generateNegotiationRoutes(
  modulePath = 'negotiation',
  prefix = '',
  sideMenuTitle = '谈判采购',
  applicableCompanyIdentities = [workbenchServiceDict.PURCHASER.value],
  roles = [platformFunctionModuleDict.PURCHASER.right],
  listRoute = {},
  needIcon = true
) {
  return {
    path: modulePath,
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: sideMenuTitle,
      icon: needIcon ? 'icon-side_purchase_negotiation' : '',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities,
    roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
    superviseInstitutions: [],

    children: [
      // 项目列表
      Object.assign(
        {},
        {
          path: 'list',
          name: `${prefix}NegotiationList`,
          component: '/procure-views/negotiation/common/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '项目列表',
            cache: true,
            hidden: true,
            pageComponentName: 'NegotiationList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities,
          roles: [
            ...roles,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },
        listRoute
      ),

      // 发布谈判
      {
        path:
          'orders/:orderId?/projects/:projectId?/edit/:isAbnormal?/copy/:isCopy?',
        name: `${prefix}NegotiationForm`,
        component: '/procure-views/negotiation/common/form',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '发布谈判',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 项目预览
      {
        path: 'orders/:orderId?/publish/preview',
        name: `${prefix}NegotiationFormPreview`,
        component: '/procure-views/negotiation/common/preview',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '项目预览',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 采购单详情
      {
        path: 'orders/:orderId/info',
        name: `${prefix}NegotiationInfo`,
        component: '/procure-views/negotiation/common/process/info/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '采购单详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 响应情况
      {
        path: 'orders/:orderId/response',
        name: `${prefix}NegotiationResponse`,
        component: '/procure-views/negotiation/common/process/response/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '响应情况',
          cache: true,
          hidden: true,
          pageComponentName: 'NegotiationResponse'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 供应商详情
      {
        path: 'orders/:orderId/audit/supplier/:applyId',
        name: `${prefix}NegotiationSupplierAudit`,
        component: '/procure-views/negotiation/common/process/response/audit',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '供应商详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 资格审查
      {
        path: 'orders/:orderId/audit/:responseId/response/round/:roundNum',
        name: `${prefix}NegotiationInvestigate`,
        component:
          '/procure-views/negotiation/common/process/response/investigate',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '资格审查',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 多次谈判
      {
        path: 'orders/:orderId/negotiate-round/:roundNum?',
        name: `${prefix}NegotiationRoundNegotiate`,
        component:
          '/procure-views/negotiation/common/process/response/negotiate-round',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '多次谈判',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 线上评审
      {
        path: ':orderId/online-review',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '线上评审',
          layout: 'DefaultLayout',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: [],

        children: [
          // 线上评审设置
          {
            path: 'setting',
            name: `${prefix}NegotiationOnlineReviewSetting`,
            component: '/procure-views/online-review/review-setting',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审设置',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 线上评审大厅
          {
            path: ':reviewId/hall',
            name: `${prefix}NegotiationOnlineReviewHall`,
            component: '/procure-views/online-review/review-hall',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审大厅',
              hidden: true,
              layout: 'NoLayout'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 线上评审报告
          {
            path: ':reviewId/report',
            name: `${prefix}NegotiationOnlineReviewReport`,
            component: '/procure-views/online-review/review-report',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审报告',
              hidden: true,
              layout: 'NoLayout'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 线上评审文件
          {
            path: 'file',
            name: `${prefix}NegotiationOnlineReviewFile`,
            component: '/procure-views/online-review/review-file',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '线上评审文件',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      },

      // 评审结果
      {
        path: 'orders/:orderId/review',
        name: `${prefix}NegotiationReview`,
        component: '/procure-views/negotiation/common/process/review/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '评审结果',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 评审结果详情
      {
        path: 'orders/:orderId/review/result',
        name: `${prefix}NegotiationReviewDetail`,
        component: '/procure-views/negotiation/common/process/review/detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '评审结果详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 候选公示
      {
        path: 'orders/:orderId/candidate/result/:abnormal?',
        name: `${prefix}NegotiationCandidate`,
        component: '/procure-views/negotiation/common/process/candidate/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '候选公示',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 候选人审批详情
      {
        path: 'orders/:orderId/candidate/audit/detail',
        name: `${prefix}NegotiationCandidateNewest`,
        component:
          '/procure-views/negotiation/common/process/candidate/candidate-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '候选人审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 候选详情
      {
        path: 'orders/:orderId/candidate/detail',
        name: `${prefix}NegotiationCandidateDetail`,
        component: '/procure-views/negotiation/common/process/candidate/detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '候选详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 成交公示
      {
        path: 'orders/:orderId/winner/result/:abnormal?',
        name: `${prefix}NegotiationWinner`,
        component: '/procure-views/negotiation/common/process/winner/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '成交公示',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 中标结果审批详情
      {
        path: 'orders/:orderId/winner/audit/detail',
        name: `${prefix}NegotiationWinnerNewest`,
        component:
          '/procure-views/negotiation/common/process/winner/winner-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '中标结果审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 成交详情
      {
        path: 'orders/:orderId/winner/detail',
        name: `${prefix}NegotiationWinnerDetail`,
        component: '/procure-views/negotiation/common/process/winner/detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '成交详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更公告
      {
        path: 'orders/:orderId/content-change',
        name: `${prefix}NegotiationContentChange`,
        component: '/procure-views/negotiation/common/changes/content-change',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更公告',
          hidden: true,
          needFormKey: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 变更审批详情
      {
        path: 'orders/:orderId/changes/content/audit/info',
        name: `${prefix}NegotiationChangeNewestDetail`,
        component:
          '/procure-views/negotiation/common/changes/change-newest-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '变更审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 澄清文件
      {
        path: 'orders/:orderId/clarification',
        name: `${prefix}NegotiationClarification`,
        component: '/procure-views/negotiation/common/changes/clarification',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '澄清文件',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 澄清审批详情
      {
        path: 'orders/:orderId/changes/clarification/audit',
        name: `${prefix}NegotiationClarificationNewestDetail`,
        component:
          '/procure-views/negotiation/common/changes/clarification-newest-detail',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '澄清审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标处理
      {
        path: 'orders/:orderId/auction',
        name: `${prefix}NegotiationAuction`,
        component: '/procure-views/negotiation/common/abnormal/auction',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标处理',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 保证金退款
      {
        path: 'orders/:orderId/guarantee/refund/list',
        name: `${prefix}NegotiationGuaranteeRefund`,
        component: '/procure-views/negotiation/common/guarantee/refund',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '保证金退款',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 流标审批详情
      {
        path: 'orders/:orderId/abnormal/auction/audit',
        name: `${prefix}NegotiationAuctionNeweat`,
        component: '/procure-views/negotiation/common/abnormal/auction-newest',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '流标审批详情',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      },

      // 追加供应商
      {
        path: 'orders/:orderId/abnormal/add-supplier',
        name: `${prefix}NegotiationAddSupplier`,
        component: '/procure-views/negotiation/common/abnormal/add-supplier',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '追加供应商',
          hidden: true
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      }
    ]
  }
}
